/**
 * THPT Theme Configuration
 *
 * Defines the branding, colors, and style for the THPT system
 * completely independent from VSAT branding.
 */

export const thptTheme = {
  // Brand Identity
  name: 'THPT Online',
  fullName: 'Hệ thống luyện thi THPT trực tuyến',
  tagline: 'ĐGNL & Hướng nghiệp qua bài Thi thử TN THPT 2026',

  // Colors (Yellow/Amber theme - matching design specifications)
  colors: {
    primary: '#F59E0B', // Amber-500 - Main yellow/amber color
    primaryDark: '#D97706', // Amber-600 - Hover state
    primaryLight: '#FEF3C7', // Amber-100 - Light background
    primaryHover: '#D97706', // Amber-600 - Hover state (alias)
    // Background colors for light/dark modes
    backgroundLight: '#F9FAFB', // Gray-50
    backgroundDark: '#111827', // Gray-900
    // Surface colors for cards and containers
    surfaceLight: '#FFFFFF', // White
    surfaceDark: '#1F2937', // Gray-800
    // Text colors
    textMainLight: '#1F2937', // Gray-800
    textMainDark: '#F3F4F6', // Gray-100
    textMutedLight: '#4B5563', // Gray-600
    textMutedDark: '#9CA3AF', // Gray-400
    // Border colors
    borderLight: '#E5E7EB', // Gray-200
    borderDark: '#374151', // Gray-700
    // Secondary colors (keeping for compatibility)
    secondary: '#22c55e', // green-500
    secondaryDark: '#16a34a', // green-600
    secondaryLight: '#4ade80', // green-400
  },

  // Logo paths - Định hướng nghề nghiệp Logo
  logo: '/logo-dinh-huong-nghe-nghiep.png',
  logoLight: '/logo-dinh-huong-nghe-nghiep.png',
  favicon: '/logo-dinh-huong-nghe-nghiep.png',

  // URLs
  domain: 'cat.edu.vn',

  // Contact & Social
  contact: {
    email: 'support@cat.edu.vn',
    website: 'https://www.cat.edu.vn/',
    facebook: 'https://www.facebook.com/IEQTE.CAT/',
    facebookGroup: 'https://www.facebook.com/groups/IEQTE.CAT/',
    youtube: 'https://www.youtube.com/@ieqtecat',
    tiktok: 'https://www.tiktok.com/@ieqte.cat',
  },

  // Features
  features: [
    {
      icon: '📚',
      title: 'Đề thi thử bám sát dạng đề TN THPT',
      description: 'Ngân hàng đề thi THPT chuẩn theo định dạng mới nhất',
    },
    {
      icon: '🎯',
      title: 'Định hướng nghề nghiệp',
      description: 'Trắc nghiệm tư vấn ngành nghề phù hợp với năng lực và sở thích',
    },
    {
      icon: '📊',
      title: 'Phân tích chi tiết',
      description: 'Báo cáo kết quả học tập và dự đoán điểm thi chính xác',
    },
    {
      icon: '⚡',
      title: 'Luyện tập thông minh',
      description: 'Hệ thống đề xuất câu hỏi dựa trên năng lực học sinh',
    },
  ],

  // Meta tags
  meta: {
    title: 'THPT Online - Luyện thi THPT & Định hướng nghề nghiệp',
    description:
      'Hệ thống luyện thi THPT trực tuyến và định hướng nghề nghiệp. Thi thử online, đề thi chuẩn Bộ Giáo dục, hỗ trợ định hướng nghề nghiệp cho học sinh THPT.',
    keywords: [
      'THPT',
      'thi THPT',
      'luyện thi online',
      'định hướng nghề nghiệp',
      'thi thử THPT',
      'đề thi THPT',
    ],
  },
};

export type ThptTheme = typeof thptTheme;
